<div class="fcr-page">
  <header class="fcr-header">
    <h2>{{ titleKey | translate }}</h2>
    <p class="fcr-intro">{{ introKey | translate }}</p>
  </header>

  <div class="alert alert-success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

  <form class="fcr-form" (ngSubmit)="send()">
    <!-- Checkbox catalog -->
    <ul class="fcr-options">
      <li *ngFor="let opt of options"
          class="fcr-option"
          [class.is-checked]="selected.has(opt.key)"
          [class.is-readonly]="isPortalRemoteReadOnly"
          (click)="toggle(opt.key)">
        <input type="checkbox"
               [checked]="selected.has(opt.key)"
               [disabled]="isPortalRemoteReadOnly"
               (click)="$event.stopPropagation(); toggle(opt.key)" />
        <div class="fcr-option__body">
          <span class="fcr-option__label">{{ opt.labelKey | translate }}</span>
          <span class="fcr-option__desc" *ngIf="opt.descKey">{{ opt.descKey | translate }}</span>
        </div>
      </li>
    </ul>

    <!-- Free-text -->
    <label class="fcr-field">
      <span>{{ 'FLEXI_CUSTOMER_REQUEST.COMMENTS_LABEL' | translate }}</span>
      <textarea [(ngModel)]="comments" name="comments" rows="4" maxlength="4000"
                [disabled]="isPortalRemoteReadOnly"
                [placeholder]="'FLEXI_CUSTOMER_REQUEST.COMMENTS_PLACEHOLDER' | translate"></textarea>
    </label>

    <!-- Testing-only recipient override (privileged users) -->
    <label class="fcr-field fcr-override" *ngIf="canOverrideRecipient">
      <span>
        {{ 'FLEXI_CUSTOMER_REQUEST.OVERRIDE_LABEL' | translate }}
        <small>{{ 'FLEXI_CUSTOMER_REQUEST.OVERRIDE_HINT' | translate }}</small>
      </span>
      <input type="email" [(ngModel)]="overrideRecipientEmail" name="overrideRecipientEmail"
             [placeholder]="'FLEXI_CUSTOMER_REQUEST.OVERRIDE_PLACEHOLDER' | translate" />
    </label>

    <div class="fcr-footer">
      <p class="fcr-cta-note">{{ 'FLEXI_CUSTOMER_REQUEST.CTA_NOTE' | translate }}</p>
      <button type="submit" class="fcr-send-btn" [disabled]="!canSend">
        <i class="pi" [ngClass]="submitting ? 'pi-spin pi-spinner' : 'pi-send'"></i>
        {{ 'FLEXI_CUSTOMER_REQUEST.SEND' | translate }}
      </button>
    </div>
  </form>
</div>
